// useBoardFieldSelection.js

import { useEffect } from 'react';

// Keeps the board field in sync with available enum fields.
const useBoardFieldSelection = ({
    type,
    hasEnumFields,
    enumFields,
    boardField,
    setBoardField,
}) => {
    useEffect(() => {
        if (type !== 'BOARD') {
            if (boardField) setBoardField('');
            return;
        }

        if (!hasEnumFields) return;

        const firstFieldKey = enumFields[0]?.name || enumFields[0]?.key || '';
        const isValid = enumFields.some((field) => {
            const fieldKey = field?.name || field?.key || '';
            return fieldKey && fieldKey === boardField;
        });

        if (!isValid) {
            setBoardField(firstFieldKey);
        }
    }, [type, hasEnumFields, enumFields, boardField, setBoardField]);
};

export default useBoardFieldSelection;
